// extracted by mini-css-extract-plugin
export default {"primary":"Button_primary__YxVnL","disabled":"Button_disabled__0L86N"};